import { useEffect } from "react";
import ReactGA4 from "react-ga4";


const useGa4Tracker = (pageLabel) => {
	
	const googleAnalyticsGA4TrackingId = process.env.REACT_APP_GA4;

	ReactGA4.initialize(googleAnalyticsGA4TrackingId);

	useEffect(() => {
		ReactGA4.send(pageLabel);
	}, []);
};

export default useGa4Tracker;

